import React, { useEffect, useState } from "react";
import "./DboardHeader.css";
import profile_picture from "../../images/profile_picture.svg";
import default_pfp from "../../images/default_pfp.svg";
import down_arrow from "../../images/down_arrow_admin.svg";
import { useNavigate, Link } from "react-router-dom";
import { CommunityOwner, SuperAdmin } from "../../Utils/Constant";
import { useDispatch, useSelector  } from "react-redux";
import { fetchProfileData } from "../../Services/Profile/ProfileApi";
import { setHeaderMessage } from "../../Services/DashboardHeader/uiSlice";
import { useLocation } from 'react-router-dom';

function DashboardHeader() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const userId = localStorage.getItem("user_id");
  const userType = localStorage.getItem("user_type");
  const firstName = localStorage.getItem("user_first_name");
  const lastName = localStorage.getItem("user_last_name");
  const [loading, setLoading] = useState(true);
  const location = useLocation();
  const [profile, setProfile] = useState({});
  const [activeTab, setActiveTab] = useState("Community Management");
  const handleLogout = () => {
    localStorage.removeItem("accessToken");
    localStorage.removeItem("user_id");
    localStorage.removeItem("user_type");
    localStorage.removeItem("user_first_name");
    localStorage.removeItem("user_last_name");
    localStorage.removeItem("refresh-token");
    localStorage.removeItem("email");
    localStorage.removeItem("access_token");
  };

  const handleChangepwassword = () => {
    navigate("/admin/passwordChange");
  };

  const { data } = useSelector((state) => state.fetchProfileData);
  const headerMessage = useSelector((state) => state.ui.headerMessage);

  const handleButtonClick = (message) => {
    setActiveTab(message);
    dispatch(setHeaderMessage(message));
  };
  useEffect(() => {

    if (location.pathname === '/super-admin/user-listing') {
      dispatch(setHeaderMessage("User Management"));
    }
    else if (location.pathname === '/super-admin/admin-profile') {
    dispatch(setHeaderMessage("My Profile"));
     }
     else if (location.pathname === '/super-admin/dashboard'){
     dispatch(setHeaderMessage("Dashboard"));
    }

    else if (location.pathname === '/super-admin/passwordChange') {
      dispatch(setHeaderMessage("Change Password"));
    }
    else{
      dispatch(setHeaderMessage("User Management"));
    }


    dispatch(fetchProfileData(userId)).finally(() => setLoading(false));
  }, [location.pathname,dispatch]);

  useEffect(() => {
    if (data) {
      setProfile(data.user_details);
    }
  }, [data]);

  return (
    <>
      <div className="header-main">
        <div className="header-inner-main d-flex justify-content-between align-items-center">
          {/* <div className="dashboard-title">Community Management</div> */}
          <div className="dashboard-title"> {headerMessage}
          <p className="m-0" style={{ fontStyle: "italic", fontWeight: 600 }}>
  Creating customizable solutions for overall wellness
</p>

             </div>

          <div className="d-flex flex-column align-items-end">
            <div class="dropdown">
              <div
                class="dropdown-toggle d-flex align-items-center gap-3 admin-profile-dropdown"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                <div className="profile-picture-admin">
                  <img
                    src={profile?.image || "https://cdn-icons-png.flaticon.com/128/18781/18781453.png"}
                    alt="Profile-picture"
                    onError={(e) => {
                      e.target.onerror = null; // Prevent infinite loop
                      e.target.src = default_pfp; // Fallback image
                    }}
                  />
                </div>

                <div className="admin-name-div">
                  {firstName + " " + lastName}
                  <span>
                    {userType === CommunityOwner
                      ? "Admin"
                      : userType === SuperAdmin
                      ? "Super Admin"
                      : "Admin"}
                  </span>
                </div>
                <div className="down-arrow-block">
                  <img src={down_arrow} alt="down-arrow"></img>
                </div>
              </div>
              <ul class="dropdown-menu">
                <li>
                  <Link
                    to={
                      userType === CommunityOwner
                        ? "/super-admin/admin-profile"
                        : userType === SuperAdmin
                        ? "/super-admin/super-admin-profile"
                        : "/super-admin/admin-profile"
                    }
                    onClick={() => dispatch(setHeaderMessage("Profile"))}
                    class="dropdown-item"
                  >
                    View Profile
                  </Link>
                </li>
                {/* <li>
                  <a class="dropdown-item" href="#">
                    Another action
                  </a>
                </li> */}
                <li>
                  <Link class="dropdown-item" onClick={handleLogout} to="/">
                    Logout
                  </Link>
                </li>
                <li>
                  <Link
                    className="dropdown-item"
                    to="/super-admin/passwordChange"
                    aria-current="page"
                  >
                    Change Password
                  </Link>
                </li>
              </ul>
            </div>
            {/* <p className="m-0 text-end">Creating customizable solutions for overall wellness</p> */}
          </div>
        </div>
      </div>
    </>
  );
}

export default DashboardHeader;
